import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, effect, forwardRef, inject } from '@angular/core';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import { OnboardingStepperComponent } from './onboarding-stepper/onboarding-stepper.component';
import { ConnectionService } from '../../core/services/connection.service';
import { OnboardingSlideComponent } from './onboarding-slide/onboarding-slide.component';
import { OnboardingResponse } from '../../shared/interfaces/onboarding.inteerface';

@Component({
  selector: 'app-onboarding',
  imports: [
    CdkStepperModule,
    MatStepperModule,
    forwardRef(() => OnboardingStepperComponent),
    OnboardingSlideComponent,
  ],
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss',
})
export class OnboardingComponent {
  private dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  private connectionService = inject(ConnectionService);
  public data = inject<OnboardingResponse>(DIALOG_DATA);
  public length = Array(this.data.slides.length) || [];

  constructor() {
    effect(() => {
      if (!this.connectionService.isOnline()) {
        this.onClose();
      }
    });
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
